import { useCallback } from 'react';
import apiClient from 'src/api/axiosClient';
import { SendTestMessageToContactApiParams } from './TestMessagesApi.types';

export function useSendTestMessageToContactApi(): SendTestMessageToContactApiParams {
  return useCallback(
    (params, companyId) => apiClient.post('/test-messages/send-to-contact', params, { params: { companyId } }),
    [],
  );
}
